module.exports = __webpack_public_path__ + "img/banner2.e89db7d8.png";